import React, { useState, useEffect } from "react";
import Link from "next/link";

import AccountBoxIcon from "@material-ui/icons/AccountBox";
import Popover from "@material-ui/core/Popover";
import UserPhoto from "components/UserPhoto";
import { projectFirestore } from "components/ProjectFirestore";
import MessageSendModal from "components/modal/MessageSendModal";
import userNameFormat from "components/userNameFormat";
import UserUid from "components/UserUid";

const ToUser = ({ email }) => {
  const [messageModalVisible, setMessageModalVisible] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [data, setData] = useState();

  /* 사용자 프로필 가져오기 */
  const photoUrl = UserPhoto(email);

  useEffect(async () => {
    try {
      const docRef = projectFirestore.collection("users").doc(email);
      const docValue = await docRef.get();
      if (docValue.exists) {
        setData({ ...docValue.data() });
      }
    } catch (error) {
      console.error(error);
      BasicAlert(error);
    }
  }, [email]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMessageSend = () => {
    setAnchorEl(null);
    setMessageModalVisible(true);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const userUid = UserUid(email);

  if (!data) return `${email}`;
  return (
    <div>
      <div className="flex items-center mb-1">
        <i className="text-888 mr-2">
          <AccountBoxIcon />
        </i>
        <p className="mb-0 text-333 text-13 font-bold cursor-pointer leading-5" onClick={handleClick}>
          {userNameFormat(data.name)}
        </p>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <div className="aiso-card aiso-shadow transition cursor-pointer max-w-sm p-4">
          <div className="w-full flex justify-center items-center">
            <div>
              <div className="img-cover-box w-16 h-16 rounded-full border">
                <img src={photoUrl} alt="" />
              </div>
            </div>
            <div className="whitespace-pre-line break-all pl-4">
              <p className="truncate-1-lines text-333 font-bold mb-2"> {data.name}</p>
            </div>
          </div>
          <div className="w-full flex justify-between items-center mt-4">
            <button className="btn btn-grayPrimary btn-sm text-13 mr-2" onClick={handleMessageSend}>
              메시지 전송
            </button>
            {/* <Link href="/admin/"> */}
            <Link
              href={{
                pathname: "/user/profile/[id]",
                query: {
                  id: `${userUid}`,
                },
              }}
            >
              <div className="btn btn-grayPrimary text-13 btn-sm">프로필 보기</div>
            </Link>
            {/* </Link> */}
          </div>
        </div>
      </Popover>
      <MessageSendModal
        messageModalVisible={messageModalVisible}
        closeModal={() => setMessageModalVisible(false)}
        receiveEmail={data.email}
        receiveUserName={data.name}
      />
    </div>
  );
};

export default ToUser;
